import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/totalVisitsSagas";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";

const TableOrStackedBarChart = () => {
  const dispatch = useDispatch();
  const tableView = useSelector((state) => state.totalVisits.selectedFilters.table_view);
  const {
    data_table: { rows = [], cols = [] },
    options
  } = useSelector((state) => state.totalVisits.chartData);

  return (
    <GoogleChart
      chartName="attendance_total_visits_chart"
      width="1350px"
      height={tableView ? 300 : 400}
      isTableView={tableView}
      rows={rows}
      columns={cols}
      options={{ ...options, legend: { position: "bottom", ...options.legend } }}
      enableEventListeners
      showCurrency={false}
      switchView={(data) => dispatch(actionCreators.updateTableView(data))}
    />
  );
};

export default TableOrStackedBarChart;
